import * as React from "react";

const DoubleArrowRight = (props) => {
  return (
    <svg width="24px" height="26px" viewBox="0 0 24 18">
      <g stroke="none" strokeWidth="1" fill="#FFFFFF" fillRule="evenodd">
        <polygon points="3.37845269 0 0 3.75 5.63075448 10 0 16.25 3.37845269 20 12.3870968 10" />
        <polygon points="14.9913559 0 11.6129032 3.75 17.2436577 10 11.6129032 16.25 14.9913559 20 24 10" />
      </g>
    </svg>
  );
};

export default DoubleArrowRight;



// WEBPACK FOOTER //
// ./src/components/Icons/DoubleArrowRight.jsx